// leagues/utils.js — 共通ユーティリティ
window.JanrecoUtils = window.JanrecoUtils || {};

// カスタムHTMLツールチップハンドラー（chart_defaults.jsから転送）
var chartDefaults = require('controllers/chart_defaults');
JanrecoUtils.externalTooltipHandler = chartDefaults.externalTooltipHandler;
JanrecoUtils.doughnutTooltipHandler = chartDefaults.doughnutTooltipHandler;

// HTML文字列エスケープ
JanrecoUtils.escapeHtml = function(str) {
  if (!str) return '';
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
};

// HTML属性値エスケープ
JanrecoUtils.escapeAttr = function(str) {
  if (!str) return '';
  return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

// hex色をrgbaに変換
JanrecoUtils.hexToRgba = function(hex, alpha) {
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);
  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
};

// ヒートマップカラースケール（白テキスト対応の濃い色）
JanrecoUtils.getPointHeatmapColor = function(value) {
  var v = parseFloat(value);
  if (v > 300)  return '#1B6E50'; // win-great
  if (v >= 200) return '#287D5E'; // win-good
  if (v >= 100) return '#358F6E'; // win-mid
  if (v > 0)    return '#43A280'; // win-low
  if (v <= -300) return '#7D2D2A'; // lose-danger
  if (v <= -200) return '#A33E3B'; // lose-heavy
  if (v <= -100) return '#B5524E'; // lose-mid
  if (v < 0)     return '#C47573'; // lose-low
  return '#999999'; // even
};

// 0ptライン強調プラグイン（Chart.js用）
JanrecoUtils.zeroLinePlugin = {
  id: 'zeroLine',
  afterDraw: function (chart) {
    var yScale = chart.scales.y;
    var ctx = chart.ctx;
    var y = yScale.getPixelForValue(0);
    if (y >= yScale.top && y <= yScale.bottom) {
      ctx.save();
      ctx.strokeStyle = 'rgba(0, 0, 0, 0.2)';
      ctx.lineWidth = 1;
      ctx.setLineDash([4, 4]);
      ctx.beginPath();
      ctx.moveTo(chart.chartArea.left, y);
      ctx.lineTo(chart.chartArea.right, y);
      ctx.stroke();
      ctx.restore();
    }
  }
};

// ホバー時に縦クロスヘアラインを描画するプラグイン（Chart.js用）
JanrecoUtils.crosshairLinePlugin = {
  id: 'crosshairLine',
  afterDatasetsDraw: function (chart) {
    var tooltip = chart.tooltip;
    if (!tooltip || tooltip.opacity === 0) return;

    var dp = tooltip.dataPoints && tooltip.dataPoints[0];
    if (!dp || !dp.element) return;

    var x = dp.element.x;
    var area = chart.chartArea;
    var ctx = chart.ctx;

    ctx.save();
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.15)';
    ctx.lineWidth = 1;
    ctx.setLineDash([4, 4]);
    ctx.beginPath();
    ctx.moveTo(x, area.top);
    ctx.lineTo(x, area.bottom);
    ctx.stroke();
    ctx.restore();
  }
};

// チームロゴ画像のロード/エラーハンドリング
JanrecoUtils.initTeamLogoImages = function() {
  $('img[data-team-logo]').each(function() {
    var $img = $(this);
    if (this.complete && this.naturalWidth > 0) {
      $img.closest('.team-logo-wrapper').addClass('has-loaded-img');
      return;
    }
    $img.on('load', function() {
      $img.closest('.team-logo-wrapper').addClass('has-loaded-img');
    });
    $img.on('error', function() {
      $img.hide();
    });
  });
};

$(document).on('turbolinks:load', function() {
  JanrecoUtils.initTeamLogoImages();
});

// 角丸四角形描画ヘルパー（Canvas用）
JanrecoUtils.roundRect = function(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.arcTo(x + w, y, x + w, y + r, r);
  ctx.lineTo(x + w, y + h - r);
  ctx.arcTo(x + w, y + h, x + w - r, y + h, r);
  ctx.lineTo(x + r, y + h);
  ctx.arcTo(x, y + h, x, y + h - r, r);
  ctx.lineTo(x, y + r);
  ctx.arcTo(x, y, x + r, y, r);
  ctx.closePath();
};

// 表示中のデータセットだけでY軸の範囲を再計算する（Chart.js用）
// 大人数リーグの総合pt推移グラフで、非表示プレイヤー（最下位など）の値にY軸が引きずられて
// 線が中央に密集するのを防ぐ。丸め方はサーバー側（League#graph_data）と揃えて100pt単位にする。
// chart._autoRescaleY が true のチャートだけが対象（呼び出し側で判定する）。
// 表示中のデータが空の場合は fallback（全員分で算出した既定値）へ戻す。
JanrecoUtils.rescaleYAxisToVisibleDatasets = function(chart, fallback) {
  if (!chart || !chart.options || !chart.options.scales || !chart.options.scales.y) return;

  let max = null;
  let min = null;
  chart.data.datasets.forEach(function(ds, i) {
    // meta.hidden（凡例クリック等）と dataset.hidden（サーバー側の初期絞り込み）の両方を見るため
    // Chart.js の isDatasetVisible を使う
    if (!chart.isDatasetVisible(i)) return;
    (ds.data || []).forEach(function(value) {
      const v = Number(value);
      if (value === null || value === undefined || isNaN(v)) return;
      if (max === null || v > max) max = v;
      if (min === null || v < min) min = v;
    });
  });

  // 表示中のデータが無い（全員非表示）ときはサーバー算出の既定値へ戻す
  if (max === null || min === null) {
    if (fallback && fallback.yMax !== undefined && fallback.yMin !== undefined) {
      chart.options.scales.y.max = fallback.yMax;
      chart.options.scales.y.min = fallback.yMin;
    }
    return;
  }

  chart.options.scales.y.max = Math.floor(max / 100) * 100 + 100;
  chart.options.scales.y.min = Math.floor(min / 100) * 100;
};

// リーグ総合pt推移グラフ用のY軸再計算ラッパー。
// 現在のグラフモード（対局別/日別）のサーバー算出値を fallback に使う。
JanrecoUtils.rescaleLeagueChartY = function(chart, chartId) {
  if (!chart || chart._autoRescaleY !== true) return;
  const modes = window.leagueGraphModes && window.leagueGraphModes[chartId];
  const fallback = modes && chart._graphMode ? modes[chart._graphMode] : null;
  JanrecoUtils.rescaleYAxisToVisibleDatasets(chart, fallback);
};
